<div class="container">
  <mat-icon
    class="filter-top-btn"
    (click)="isFilterOpen = true"
    matTooltip="Table Filter"
  >
    filter_list
  </mat-icon>
  <p class="title">
    Sailing Performance
    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial Performance
    <mat-icon class="titleIcon">chevron_right</mat-icon> Periodic
    Report<mat-icon class="titleIcon">chevron_right</mat-icon>Periodic Report
    Table
  </p>

  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter-panel dark-filter">
      <!-- HEADER -->
      <div class="filter-header">
        <div class="header-left">
          <mat-icon>filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="isFilterOpen = false">close</mat-icon>
      </div>

      <!-- BODY -->
      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-grid">
          <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="filterForm.controls['from_date']"
          ></app-custom-date-picker>

          <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="filterForm.controls['to_date']"
          ></app-custom-date-picker>

          <div class="col">
            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">Ship Name</label>
            <input
              type="text"
              class="form-control shipName"
              id="shipName"
              formControlName="vessel"
              (input)="filterShipNames($event)"
              [matAutocomplete]="autoShip"
            />
            <mat-autocomplete #autoShip="matAutocomplete">
              <mat-option *ngFor="let ship of shipNameSuggestions" [value]="ship.vessel_name">
                {{ ship.vessel_name }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </form>

      <!-- FOOTER -->
      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>

        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>
    </div>
  </div>

  <div class="table-action-row" style="margin-bottom: 10px; display: flex; justify-content: flex-end;">
    <button
      class="gradient-btn"
      style="border-radius: 8px; border: none; padding: 6px 12px; color: white; background: #498ff4; height: 40px;"
      (click)="openMergeConvertDialog()"
    >
      <mat-icon style="vertical-align: middle;">merge_type</mat-icon>
      <span class="name" style="vertical-align: middle; margin-left: 4px;">Merge / Convert Reports</span>
    </button>
  </div>

  <!-- <div class="text-right topBtn" *ngIf="username === 'Meraki - Operations'" >
    <mat-slide-toggle (change)="toggleExistingView()">
      {{ toggleView ? "Existing" : "New" }}</mat-slide-toggle
    >
    <button
      class="btn btn-light hover-button apply"
      (click)="addRow()"
      
      *ngIf="addRowBtn"
    >
      <mat-icon>add</mat-icon>
      <span class="name">Add Row</span>
    </button>
  </div> -->

  <div class="table-container scroll-bar">
    <table class="mat-elevation-z8" id="style-4" matSort [ngClass]="{ 'dark-table': isDarkMode() }">
      <thead style="font-size: 11px" class="fixed-header">
        <tr>
          <th>S.No</th>
          <th><span>Ship Name</span></th>
          <th><span>I.M.O Number</span></th>
          <th>Start Date & Time</th>
          <th>End Date & Time</th>
          <th>Condition</th>
          <th>MerakiPic</th>
          <th>Status</th>
          <!-- <th *ngIf="generateReport && toggleView">upload</th>
          <th *ngIf="generateReport">Submit</th> -->
          <th>View</th>
          <th>Periodic Report</th>
          <th>Periodic summary Report</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="isLoadingTable">
          <tr class="skeleton-row" *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <td><div class="skeleton skeleton-text short"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text short"></div></td>
            <td><div class="skeleton skeleton-text short"></div></td>
            <td><div class="skeleton skeleton-text short"></div></td>
            <td><div class="skeleton skeleton-btn"></div></td>
            <td><div class="skeleton skeleton-btn"></div></td>
            <td><div class="skeleton skeleton-btn"></div></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!isLoadingTable">
               <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td>{{ rowIndex + 1 }}</td>
          <td>
            {{ formatVesselName(element.vessel_name) }}
          </td>
          <td>{{ element.imo_number }}</td>
          <td>
            {{ element.start_time | date : "dd MMM yyyy, HH:mm" }}
          </td>
          <td>
            {{ element.end_time | date : "dd MMM yyyy, HH:mm" }}
          </td>
          <td>
            {{ element.voyage_type }}
          </td>
          <td>
            {{ element.merakipic }}
          </td>
          <td>
            {{ element.status }}
          </td>
          <td>
            <button class="gradient-btn" [ngStyle]="{
                'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                'border-radius': '11px',
                border: 'none'
              }" (click)="showDetails(element)">
              <mat-icon fontSet="material-icons-outlined" fontIcon="visibility"
                class="visiblityIcon">visibility_outlined</mat-icon>
            </button>
          </td>
          <td>
            <button class="downloadIcon" (click)="downloadIcon(element)" [disabled]="!element.periodic_s3_link"
              [ngStyle]="{
                color: element.periodic_s3_link ? '#008000' : 'inherit'
              }">
              <mat-icon>download</mat-icon>
            </button>
          </td>
          <td>
            <button class="downloadIcon" (click)="downloadSummaryIcon(element)" [disabled]="!element.s3_periodic_link"
              [ngStyle]="{
                color: element.s3_periodic_link ? '#008000' : 'inherit'
              }">
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </tr>

        </ng-container>
     
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="tableData.length" [pageSizeOptions]="[100]" [pageSize]="itemsPerPage"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons></mat-paginator>
  <br />
  <div class="text-right">
    <!-- <button class="btn btn-light hover-button mail">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button> -->
    <button class="btn btn-light hover-button mail" (click)="backClick()">
      <mat-icon>back</mat-icon>&nbsp; Back
    </button>
    <!-- <button class="btn btn-light hover-button mail">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button> -->
  </div>
</div>